import { MapContainer, Marker, Popup, TileLayer,ZoomControl, LayersControl,useMap, useMapEvents, GeoJSON } from 'react-leaflet'
import React, { useState,useRef,useEffect, forwardRef, useImperativeHandle } from 'react'
import 'esri-leaflet-geocoder/dist/esri-leaflet-geocoder.css';
import { icon,icon_new_data } from '../custom_icon';
import "react-leaflet-markercluster/dist/styles.min.css";
import { OpenStreetMapProvider, GeoSearchControl } from 'leaflet-geosearch'
import "leaflet-geosearch/dist/geosearch.css";
import './MapComponent.css';
import {useNavigate} from 'react-router-dom';

import emailjs from '@emailjs/browser';

import { toast } from 'react-toastify';
import { LatLngBounds } from "leaflet";
import axios from 'axios';
import jwtDecode from 'jwt-decode';


function LeafletgeoSearch() {
  const map = useMap();
  useEffect(() => {
    const provider = new OpenStreetMapProvider();
    const searchControl = new GeoSearchControl({
      provider,
      marker: {
        icon
      }
    });
    map.addControl(searchControl);
    return () => map.removeControl(searchControl)
  }, []);
  return null;
}

async function sendEmail(e) {
  e.preventDefault();

  const fileInput = document.querySelector('input[type="file"]');
  if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
    toast.error("Devi prima selezionare un file!");
    return;
  }

  const toastId = toast.info("Invio richiesta in corso...", {
    autoClose: false,
    closeOnClick: false,
    draggable: false,
  });

  try {
    // STEP 1: Upload del file
    const fileFormData = new FormData();
    fileFormData.append("file", fileInput.files[0]);

    const uploadResponse = await axios.post(
      "https://hat.sofhare.com/upload-zip-da-elaborare/",
      fileFormData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${localStorage.getItem("token")}`
        },
      }
    );

    // STEP 2: Prepara form per email
    const form = e.target;
    const emailFormData = new FormData(form);

    // STEP 3: Invia email
    const emailResponse = await axios.post(
      "https://hat.sofhare.com/submit-prova/",
      emailFormData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${localStorage.getItem("token")}`
        },
      }
    );

    toast.update(toastId, {
      render: emailResponse.data.message || "Prova inviata con successo!",
      type: toast.SUCCESS,
      autoClose: 2000,
    });

    form.reset();

  } catch (err) {
    console.error("ERRORE DETTAGLIATO:", {
      message: err.message,
      response: err.response?.data,
      status: err.response?.status,
      headers: err.response?.headers,
      config: err.config
    });

    toast.update(toastId, {
      render: err.response?.data?.error || `Errore ${err.response?.status}: ${err.message}`,
      type: toast.ERROR,
      autoClose: 5000,
    });
  }
}


export const MapComponent_Page3 = forwardRef(({ addMarker,mapClickActive }, ref) => {

  axios.defaults.headers.common["Authorization"] =`Bearer ${localStorage.getItem("token")}`;

  const mapRef = useRef();
  const inputRef = useRef(null);
  const [markers, setMarkers] = useState(null);
  const [manualMarks, setManualMarks] = useState([]);
  const [mapCenter, setMapCenter] = useState([44.36, 11.34]);

  const [coordinates, setCoordinates] = useState({ lat: '', lng: '' });

  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState('');
  const [geojsonFiles, setGeojsonFiles] = useState([]);

  const [username, setUsername] = useState(null);

  const [openOverlayIndex, setOpenOverlayIndex] = useState(null);

  const handleMapClick = (e) => {
    if (!mapClickActive) return; // usa sempre la prop aggiornata
    const { lat, lng } = e.latlng;
    setManualMarks(prev => [...prev, { lat, lng }]);
    setMapCenter([lat, lng]);
    mapRef.current?.setView([lat, lng]);
  };

  const addMapClickListener = (map) => {
    mapRef.current = map;
  };

  // Riaggancia il click listener ogni volta che mapClickActive cambia
  useEffect(() => {
    const map = mapRef.current;
    if (!map) return;

    // rimuovi vecchio listener prima di aggiungerne uno nuovo
    map.off('click', handleMapClick);
    map.on('click', handleMapClick);

    return () => {
      map.off('click', handleMapClick);
    };
  }, [mapClickActive]);

  const fileInputRef = useRef(null); // Riferimento al file input
  const [uploadProgress, setUploadProgress] = useState(0);

  const handleUploadClick = (e) => {
    e.stopPropagation(); // Impedisce la propagazione dell'evento
    fileInputRef.current?.click(); // Apre il file picker nativo
  };


const handleFileChange = async (event) => {
  const file = event.target.files[0];
  if (!file) return;

  const ext = file.name.split('.').pop().toLowerCase();
  if (!["zip", "rar"].includes(ext)) {
    alert("Sono consentiti solo file ZIP o RAR.");
    return;
  }

  // Mostra il nome del file nella line edit
  const fileName = file.name;
  document.getElementById('url_data').value = fileName;

  // Opzionale: mostra un toast di conferma
  toast.success(`File selezionato: ${fileName}`);
};

      // FUNZIONE 1: Solo per mostrare il nome del file nella line edit (NO UPLOAD)
const uploadFile = (e) => {
  e.preventDefault();

  const fileInput = document.querySelector('input[type="file"]');
  if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
    toast.error("Seleziona un file");
    return;
  }

  // Prende solo il nome del file dal file selezionato
  const fileName = fileInput.files[0].name;

  // Lo scrive nella line edit
  document.getElementById('url_data').value = fileName;

  toast.success(`File selezionato: ${fileName}`);
};




  // Use this effect to attach the listener after the map is created
  useEffect(() => {
    const map = mapRef.current;
    if (map) {
      map.on('click', handleMapClick);
    }
    return () => {
      if (map) {
        map.off('click', handleMapClick);
      }
    };
  }, [mapRef.current]);

  const handleAddMarker = () => {
            const inputCoordinates = inputRef.current.value.split(",");
            if (inputCoordinates.length === 2) {
               const [lat, lng] = inputCoordinates.map((coord) => parseFloat(coord));
            if (!isNaN(lat) && !isNaN(lng)) {
                    setManualMarks({ lat, lng });
                    setMapCenter([lat, lng]);
                    const map = mapRef.current;
                    if (map) {
                    map.setView([lat, lng]);
                      }
                    }
      };}

  // Function to remove a marker on double-click
      const handleMarkerDoubleClick = (index) => {
            setManualMarks((prevMarks) => prevMarks.filter((_, i) => i !== index));
      };

      const handleMarkerClick = (lat, lng, index) => {
            setCoordinates({ lat, lng }); // Update the coordinates state
            // No toggle here, only for button click
      };

    useImperativeHandle(ref, () => ({
        downloadGeoJSON,
        handleProjectChange,
        getProjects: () => projects,

        fetchProjects: async () => {
            try {
                const response = await axios.get(
                    "https://hat.sofhare.com/user-projects/"
                );

                const projectsData = response.data.projects;

                setProjects(Object.keys(projectsData));
                setGeojsonFiles(projectsData);

                return Object.keys(projectsData);

            } catch (err) {
                console.error("Errore caricamento progetti:", err);
                return [];
            }
        }
    }));

        useEffect(() => {
            if (!selectedProject || !geojsonFiles[selectedProject]) return;

            const geojsonFilesForProject = geojsonFiles[selectedProject];

            const loadMarkers = async () => {
            const allNewMarkers = await Promise.all(
                geojsonFiles[selectedProject].map(async (file) => {
                    try {
                        const response = await axios.get(
                            `https://hat.sofhare.com/user-photo-link/${selectedProject}/${file.properties.photo}`,
                            {
                                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
                            }
                        );

                        return {
                            lat: file.coordinates[1],
                            lng: file.coordinates[0],
                            name: file.properties.name,
                            type: file.properties.type,
                            photo: response.data.photo_url
                        };
                    } catch (err) {
                        // Log completo dell’errore
                        console.error("Errore caricando la foto:", file.properties.photo);
                        if (err.response) {
                            // La richiesta è stata fatta e il server ha risposto con status != 2xx
                            console.error("Status:", err.response.status);
                            console.error("Response data:", err.response.data);
                            console.error("Response headers:", err.response.headers);
                        } else if (err.request) {
                            // La richiesta è stata fatta ma non è arrivata risposta
                            console.error("Request fatta ma nessuna risposta:", err.request);
                        } else {
                            // Qualche altro errore
                            console.error("Errore configurazione axios:", err.message);
                        }
                        return {
                            lat: file.coordinates[1],
                            lng: file.coordinates[0],
                            name: file.properties.name,
                            type: file.properties.type,
                            photo: null
                        };
                    }
                })
            );

            setMarkers(allNewMarkers);

            if (allNewMarkers.length > 0 && mapRef.current) {
                mapRef.current.setView([allNewMarkers[0].lat, allNewMarkers[0].lng], 10);
            }
        };

            loadMarkers();
        }, [selectedProject, geojsonFiles]);

        // Tua funzione originale rimane esattamente così
        const handleProjectChange = (e) => {
            const projectName = e.target.value;

            setSelectedProject(projectName);
            setMarkers([]); // cancella i marker prima del nuovo effetto
        };


          // Function to download GeoJSON file of all markers
      
      const downloadGeoJSON = async () => {
    if (!markers || markers.length === 0) {
        console.error('No markers available to download.');
        return;
    }

    // 1️⃣ Costruisci GeoJSON
    const geojson = {
        type: 'FeatureCollection',
        features: markers.map(marker => ({
            type: 'Feature',
            geometry: {
                type: 'Point',
                coordinates: [marker.lng, marker.lat],
            },
            properties: {
                name: marker.name,
                type: marker.type,
                photo: marker.photo,
            },
        })),
    };

    // 2️⃣ Scarica GeoJSON
    const geojsonStr = JSON.stringify(geojson, null, 2);
    const blob = new Blob([geojsonStr], { type: 'application/geo+json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${selectedProject || 'markers'}.geojson`;
    a.click();
    URL.revokeObjectURL(url);

    // 3️⃣ Scarica tutte le foto in sequenza
    for (let i = 0; i < markers.length; i++) {
    const photoUrl = markers[i].photo;
    if (photoUrl) {
        try {
            const response = await fetch(photoUrl, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            });

            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

            const photoBlob = await response.blob();
            const photoLink = document.createElement('a');

            // Estrai il nome file originale dall'URL
            const urlParts = photoUrl.split('/');
            const originalFileName = urlParts[urlParts.length - 1].split(/\#|\?/)[0];

            photoLink.href = URL.createObjectURL(photoBlob);
            photoLink.download = originalFileName; // usa il nome originale
            photoLink.click();
            URL.revokeObjectURL(photoLink.href);
        } catch (err) {
            console.warn(`Errore nel download della foto ${photoUrl}`, err);
        }
    }
}
};

const openPhoto = async (photoUrl) => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.get(photoUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: "blob",
    });

    const blobUrl = URL.createObjectURL(response.data);

    window.open(blobUrl, "_blank");

    setTimeout(() => {
      URL.revokeObjectURL(blobUrl);
    }, 60000);

  } catch (err) {
    console.error("Errore apertura foto:", err);
    toast.error("Impossibile aprire la foto.");
  }
};

 return (
        <div className="general">
            <div className="map1" style={{ position: 'relative' }}>

            <a href="/#" id="downloadAnchorElem" style={{ display:"none" }} >a</a>
                <MapContainer  center={mapCenter} zoom={10} zoomControl={false} whenCreated={addMapClickListener} style={{ height: '100%', width: '100%',borderRadius: '7px'}}>
                    <LayersControl position="topright">
                        <LayersControl.BaseLayer checked name="OpenStreetMap.HOT">
                          <TileLayer
                            url='https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png'
                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Tiles style by <a href="https://www.hotosm.org/" target="_blank">Humanitarian OpenStreetMap Team</a> hosted by <a href="https://openstreetmap.fr/" target="_blank">OpenStreetMap France</a>'
                          />
                        </LayersControl.BaseLayer>

                        <LayersControl.BaseLayer unchecked name="Satellite ESRI">
                            <TileLayer
                                url='https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
                                attribution='Map Tiles © 2022 Esri, Maxar, Earthstar Geographics, CNES/Airbus DS, USDA FSA, USGS,Getmapping, Aerogrid, IGN, IGP, and the GIS User Community'
                            />
                        </LayersControl.BaseLayer>
                      </LayersControl>
                    <ZoomControl position='topleft'/>

                   <LeafletgeoSearch />

                   {/* Render the markers */}
                    {markers && markers.map((marker, index) => (
                        <Marker
                            key={index}
                            position={[marker.lat, marker.lng]}
                            icon={icon_new_data}
                            eventHandlers={{
                                click: (e) => { // Add the click event handler to the marker

                                    handleMarkerClick(marker.lat, marker.lng, index); // Handle marker click
                                }
                            }}
                        >
                            <Popup>
                                <div>
                                    <div className="form_data">
                                        <form className="contact-form" onSubmit={sendEmail}>
                                            <input
                                                type="text"
                                                id="tipo_prova"
                                                name="tipo_prova"
                                                defaultValue={marker.name}
                                                required
                                                readOnly
                                            />
                                            <br/>
                                            <input
                                              type="text"  // o type="text" se vuoi mostrarlo
                                              name="coordinate"
                                              defaultValue={`${marker.lat}, ${marker.lng}`}  // <-- COSÌ PRENDE DAL MARKER
                                              required
                                              readOnly
                                            />
                                            <br/>
                                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                              {/* Campo readonly per il nome del file */}
                                              <input
                                                type="text"
                                                id="url_data"
                                                name="url_data"
                                                placeholder="load data"
                                                readOnly
                                                style={{ width: '120px' }} // prende tutto lo spazio disponibile
                                              />

                                              {/* File picker nascosto */}
                                              <input
                                                type="file"
                                                accept=".zip,.rar"
                                                style={{ display: 'none' }}
                                                ref={fileInputRef}
                                                onChange={handleFileChange}
                                              />
                                              {/* Bottone per aprire il file picker */}
                                              <button
                                                type="button"
                                                className="attachment"
                                                onClick={handleUploadClick}
                                              >
                                                Carica
                                              </button>
                                            </div>
                                            {marker.photo && (
                                              <span style={{
                                                fontSize: '16px',
                                                lineHeight: '13px',
                                                color: '#0066cc',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                              }}>
                                                <a
                                                  href="#"
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    openPhoto(marker.photo);
                                                  }}
                                                  style={{ color: '#12e3e3', textDecoration: 'none' }}
                                                >
                                                  Apri foto
                                                </a>
                                            </span>
                                            )}
                                            <br />
                                            <textarea
                                                id="note"
                                                name="note"
                                                defaultValue="-Inserisci note-"
                                            ></textarea>
                                            <br/>
                                            <input
                                                type="hidden"
                                                name="photo_url"
                                                value={marker.photo}
                                            />
                                            <input
                                                type="submit"
                                                value="Invia richiesta"
                                            />
                                        </form>
                                    </div>
                                </div>
                            </Popup>
                        </Marker>
                   ))}

        
                   {/* Render the manual markers */}
                   {manualMarks.length > 0 && manualMarks.map((marker, index) => ( // Use index2 for manual markers
                        <Marker
                            key={`manual-${index}`} // Use index2 for unique key
                            position={[marker.lat, marker.lng]}
                            icon={icon_new_data}
                            eventHandlers={{
                                dblclick: () => handleMarkerDoubleClick(index), // Use index2
                                click: (e) => { // Handle marker click
                                    //e.preventDefault(); // Prevent default behavior to avoid unintended actions
                                    handleMarkerClick(marker.lat, marker.lng, index); // Use index2 here as well
                                }
                            }}
                        >
                            <Popup>
                                <div>
                                    <h3>Nuova prova</h3>
                                    <div className="form_data">
                                        <form className="contact-form" onSubmit={sendEmail}>
                                            <input
                                                type="text"
                                                id="tipo_prova"
                                                name="tipo_prova"
                                                defaultValue="-Tipo/Nome prova-"
                                                required
                                            />
                                            <br />
                                            <br />
                                            <input
                                                type="text"
                                                id='coord'
                                                name="coordinate"
                                                defaultValue={`${marker.lat}, ${marker.lng}`} // Use marker's lat/lng
                                                required
                                                readOnly
                                            />
                                            <br />
                                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                              {/* Campo readonly per il nome del file */}
                                              <input
                                                type="text"
                                                id="url_data"
                                                name="url_data"
                                                placeholder="load data"
                                                readOnly
                                                style={{ width: '120px' }} // prende tutto lo spazio disponibile
                                              />

                                              {/* File picker nascosto */}
                                              <input
                                                type="file"
                                                accept=".zip,.rar"
                                                style={{ display: 'none' }}
                                                ref={fileInputRef}
                                                onChange={handleFileChange}
                                              />

                                              {/* Bottone per aprire il file picker */}
                                              <button
                                                type="button"
                                                className="attachment"
                                                onClick={handleUploadClick}
                                              >
                                                Carica
                                              </button>
                                            </div>
                                            <textarea
                                                id="note"
                                                name="note"
                                                defaultValue="-Inserisci note-"
                                            ></textarea>
                                            <br />
                                            <input
                                                type="submit"
                                                value="Invia richiesta"
                                            />
                                        </form>
                                    </div>
                                </div>
                            </Popup>
                        </Marker>
                   ))}
                </MapContainer>

            </div>

        </div>

  )

});
